import React from 'react'

/*
This component represents the "new" (post-december 2020) way we should be loading legacy images from Beaker. Allows for a 2x retina image, with a backup of a 1x image, and is backwards-compatible.


image parameter takes the shape:
    "image": {
        "id": "76942d14-f95f-45c5-b2c8-73e41a823005",
        "name": "iStock-1131049630-personalityQuestion",
        "source": "iStock",
        "link": "",
        "altAttribute": "airplane flying through sunset"
    }


*/

const getImageSources = (image, baseURL) => {
  if (typeof image === 'string') {
    return {
      oneXSrc: image,
      twoXSrc: image,
      alt: '',
    }
  }

  const imgSrc = image.mock || `${baseURL}/${image.id}`
  return {
    oneXSrc: imgSrc,
    twoXSrc: `${imgSrc}_2x`,
    alt: image.alt || image.altAttribute || image.name,
  }
}

const LegacyRetinaImage = ({
  image,
  baseURL = `${process.env.SITE_ASSET_URL}`,
  className = '',
  ...props
}) => {
  if (!image) return null

  const { oneXSrc, twoXSrc, alt } = getImageSources(image, baseURL)

  if (!oneXSrc) return null

  return (
    <img
      className={`dailybreak-retina-image${className ? ` ${className}` : ''}`}
      style={{ width: `100%` }}
      srcSet={`${oneXSrc} 1x, ${twoXSrc} 2x`}
      src={oneXSrc}
      alt={alt}
      {...props}
    />
  )
}

export default LegacyRetinaImage
